import React, { useEffect }  from 'react';
import PropTypes from 'prop-types';
import { Form, Loader } from 'semantic-ui-react';
import Fields from './CreditorFields';
import { useMapToOptions } from '../utilities';
import { Field } from '../PolicyForm';
import styles from './CreditorForm.module.scss';
import useDebounce from '../../../../../helpers/debounce';

const CreditorSubForm = ({ form, isEdit, addressLookup, addressState }) => {
	const creditorTypeOptions = useMapToOptions(Fields.creditorType.options);
	const stateOptions = useMapToOptions(Fields.creditorAddressStateId.options(), false, null, Fields.creditorAddressStateId.base);

	const debounceZip = useDebounce(form.data.creditorAddressZip, 500);
	useEffect(() => {
        addressLookup(debounceZip);
	}, [addressLookup, debounceZip]);

	return (
		<React.Fragment>
			<Field name='creditorType' as={Form.Dropdown} {...form} options={creditorTypeOptions} selection disabled={isEdit} />
			{form.data.creditorType === 0 && (
				<React.Fragment>
					<Field name='creditorBusinessName' {...form} disabled={isEdit} />
				</React.Fragment>
			)}

			{form.data.creditorType !== 0 && (
				<React.Fragment>
					<Field name='creditorFirstName' {...form} disabled={isEdit} />
					<Field name='creditorLastName' {...form} disabled={isEdit} />
				</React.Fragment>
			)}

			<Form.Group>
				<Field name='creditorAddressHouseNumber' {...form} />
				<Field name='creditorAddressStreetName' {...form} />
			</Form.Group>
			<Form.Group>
				<Field name='creditorAddressApartmentNumber' {...form} />
				<Field name='creditorAddressPOBox' {...form} />
			</Form.Group>
            <Form.Group>
				<Field name='creditorAddressZip' {...form} />
                <Form.Field className={styles.loadingBox}>
                    {addressState.loadingAddress && (
						<React.Fragment>
							<Loader active inline />
							<span className={styles.validating}>Validating zip code</span>
						</React.Fragment>
					)}
                </Form.Field>
			</Form.Group>
			<Form.Group>
				<Field name='creditorAddressCity' {...form} />
				<Field as={Form.Dropdown} name='creditorAddressStateId' {...form} options={stateOptions} search selection />
			</Form.Group>
		</React.Fragment>
	);
};

CreditorSubForm.propTypes = {
	form: PropTypes.any.isRequired,
	isEdit: PropTypes.bool
};

export default CreditorSubForm;
